import ReactGA from "react-ga";

const initGA = () => {
  ReactGA.initialize("UA-193069857-1"); // put your tracking id here
};

const GAevent = (categoryName, eventName, buttonLabel) => {
  ReactGA.event({       
      category: categoryName,  // Required
      action: eventName,       // Required
      label: buttonLabel,       
      value: 10,       
      nonInteraction: false     
  });
}

export { initGA, GAevent };
